import {isFreeAlbum, isFreeTrack, isNameYourPrice, isPurchaseAvail, isSubscribeRequired} from './albumProvider';
import {ENTITY_GET_REQUIREMENT} from './albumProviderConstant';

export function getEntityGetRequirement(album, track?) {
  if (!isPurchaseAvail(album, track)) {
    return ENTITY_GET_REQUIREMENT.NONE;
  }
  const isSubscribe = isSubscribeRequired(track ? track : album);
  if (isSubscribe) {
    return ENTITY_GET_REQUIREMENT.SUBSCRIBE;
  }
  const isFree = track ? isFreeTrack(track) : isFreeAlbum(album);
  if (isFree) {
    return ENTITY_GET_REQUIREMENT.FREE;
  }
  if (isNameYourPrice(track ? track : album)) {
    return ENTITY_GET_REQUIREMENT.NAME_YOUR_PRICE;
  }
  return ENTITY_GET_REQUIREMENT.BUY;
}
